export default [
  {
    title: 'modules.market.Estudo do Mercado', /* <i18n path="modules.market.Estudo do Mercado"></i18n> */
    route: { name: 'market', params: {} },
    icon: 'HomeIcon',
    resource: 'Geral',
    action: 'manager',
  },
]
